import React from 'react';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

export function ReabrirCompetencia({ modalData }) {
  return (
    <div>
      {modalData?.data?.periodo ? (
        <span>
          <b>Período: </b> {modalData?.data?.periodo}
        </span>
      ) : (
        ''
      )}
      {modalData?.data?.cnes ? (
        <span>
          <b>, CNES Solicitante: </b> {modalData?.data?.cnes}
        </span>
      ) : (
        ''
      )}

      {/* <div>
        <span>Data</span>
        <p>
          {modalData &&
            modalData?.dataCriacao &&
            format(
              new Date(`${modalData.dataCriacao}`),
              'dd/MM/yyyy - HH:mm:ss',
              {
                locale: ptBR,
              }
            )}
        </p>
      </div> */}
    </div>
  );
}
